<page-toolbar [title]="'myProfile.title' | translate"></page-toolbar>

<page-content *ngIf="!isReadOnly">
  <mat-card appearance="outlined" class="form-container">
    <ng-template formHost></ng-template>
  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined" class="form-container">

    <mat-card-title>{{'myProfile.changeCredentials' | translate}}</mat-card-title>

    <mat-slide-toggle [(ngModel)]="changePassword" color="primary">{{'myProfile.changePW' | translate}}</mat-slide-toggle>
    <password-confirm (validation)="onPasswordValidatiton($event)" *ngIf="changePassword"></password-confirm>

    <div *ngIf="changePassword">

      <h4>{{'myProfile.validation' | translate}}</h4>

      <input [(ngModel)]="email" matInput name="email" placeholder="Old e-mail address" style="display: none;">

      <mat-form-field>
        <input [(ngModel)]="password" matInput name="password" placeholder="{{'myProfile.previousPassword' | translate}}" type="password">
      </mat-form-field>
    </div>

  </mat-card>

  <div class="spacer"></div>
  <button (click)="onSave()" [disabled]="(changePassword && !passwordNew) || (changeEmail && !validateEmail()) && !password" mat-button>
    <mat-icon>save</mat-icon>
    {{'general.save' | translate}}</button>
</page-content>
<page-content *ngIf="isReadOnly">
  <mat-card appearance="outlined">
    <mat-card-title>{{'myProfile.notAllowed' | translate}}</mat-card-title>
  </mat-card>
</page-content>

